import React, { Component } from "react";
import * as d3 from "d3";
import styled from "styled-components";
import { connect } from "react-redux";

import { devices, getDevice } from "../../services/getDevice";

const GraphContainer = styled.div`
  width: 100%;
  height: 250px;
  text-align: center;
  margin: auto;

  circle {
    fill: transparent;
    stroke: #2e7074;
    stroke-width: 2px;
    cursor: pointer;
  }
  text {
    fill: ${props => props.theme.textHighlight};
  }

  .bubble-axis path,
  .bubble-axis line,
  .bubble-central-axis line,
  .bubble-central-axis path {
    fill: none;
    stroke: #1b567a;
    stroke-width: 1px;
    stroke-dasharray: 1.5 2;
  }

  .bubble-axis text,
  .bubble-central-axis text {
    display: none;
  }

  .bubble-cells path {
    fill: none;
    pointer-events: all;
    cursor: pointer;
  }

  .bubble-cells :hover circle {
    fill: #2e7074;
  }

  .bubble-cells-secondary path {
    fill: none;
    pointer-events: all;
  }

  .bubble-cells-secondary :hover circle {
    fill: #e26a71;
  }
  .bubble-cells-secondary circle {
    fill: #e26a71;
    stroke: #e26a71;
    stroke-width: 2px;
  }

  .bubble-counts text {
    font-size: 15px;
  }

  .bubble-counts .small {
    font-size: 10px;
  }
  .bubble-percentageValue {
    font-size: 9px;
  }

  @media (min-width: 1800px) {
    width: 80%;
    height: 320px;
    circle {
      stroke-width: 3px;
    }
    .bubble-percentageValue {
      font-size: 16px;
    }
    .bubble-counts text {
      font-size: 20px;
    }

    .bubble-counts .small {
      font-size: 12px;
    }
    .bubble-axis path,
    .bubble-axis line,
    .bubble-central-axis line,
    .bubble-central-axis path {
      stroke-width: 2px;
      stroke-dasharray: 2.55 3.39;
    }
  }

  @media (max-width: 575px) {
    height: 200px;
    circle {
      stroke-width: 1px;
    }

    .bubble-percentageValue {
      font-size: 10px;
    }
    .bubble-axis path,
    .bubble-axis line,
    .bubble-central-axis line,
    .bubble-central-axis path {
      stroke-width: 1px;
      stroke-dasharray: 2.55 3.39;
    }

    .bubble-counts text {
      font-size: 18px;
    }
  }
`;

class ServicesBubbleGraph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [
        {
          id: 0,
          value: 81,
          entity: "Ecosys"
        },
        {
          id: 1,
          value: 16,
          entity: "Equitax"
        },
        {
          id: 2,
          value: 27,
          entity: "Datagene"
        },
        {
          id: 3,
          value: 14,
          entity: "Kenegy"
        },
        {
          id: 4,
          value: 43,
          entity: "Isopop"
        },
        {
          id: 5,
          value: 67,
          entity: "Pathways"
        },
        {
          id: 6,
          value: 28,
          entity: "Pharmex"
        },
        {
          id: 7,
          value: 24,
          entity: "Multron"
        },
        {
          id: 8,
          value: 25,
          entity: "Medicroix"
        },
        {
          id: 9,
          value: 47,
          entity: "Waterbaby"
        },
        {
          id: 10,
          value: 90,
          entity: "Elemantra"
        },
        {
          id: 11,
          value: 43,
          entity: "Waretel"
        },
        {
          id: 12,
          value: 30,
          entity: "Bugsall"
        },
        {
          id: 13,
          value: 76,
          entity: "Anarco"
        },
        {
          id: 14,
          value: 90,
          entity: "Poshome"
        },
        {
          id: 15,
          value: 85,
          entity: "Lyrichord"
        },
        {
          id: 16,
          value: 53,
          entity: "Comstruct"
        },
        {
          id: 17,
          value: 28,
          entity: "Nimon"
        },
        {
          id: 18,
          value: 30,
          entity: "Zaj"
        },
        {
          id: 19,
          value: 43,
          entity: "Talkola"
        },
        {
          id: 20,
          value: 10,
          entity: "Dymi"
        },
        {
          id: 21,
          value: 70,
          entity: "Atomica"
        },
        {
          id: 22,
          value: 36,
          entity: "Quiltigen"
        },
        {
          id: 23,
          value: 56,
          entity: "Steelfab"
        },
        {
          id: 24,
          value: 93,
          entity: "Ronbert"
        },
        {
          id: 25,
          value: 28,
          entity: "Remold"
        },
        {
          id: 26,
          value: 13,
          entity: "Opticon"
        },
        {
          id: 27,
          value: 92,
          entity: "Exospace"
        },
        {
          id: 28,
          value: 70,
          entity: "Zentury"
        },
        {
          id: 29,
          value: 58,
          entity: "Grok"
        },
        {
          id: 30,
          value: 93,
          entity: "Genmy"
        },
        {
          id: 31,
          value: 49,
          entity: "Crustatia"
        },
        {
          id: 32,
          value: 53,
          entity: "Calcula"
        },
        {
          id: 33,
          value: 89,
          entity: "Dentrex"
        },
        {
          id: 34,
          value: 48,
          entity: "Imperium"
        },
        {
          id: 35,
          value: 27,
          entity: "Signity"
        },
        {
          id: 36,
          value: 95,
          entity: "Firewax"
        },
        {
          id: 37,
          value: 24,
          entity: "Quizka"
        },
        {
          id: 38,
          value: 33,
          entity: "Isotrack"
        },
        {
          id: 39,
          value: 91,
          entity: "Rodeology"
        },
        {
          id: 40,
          value: 62,
          entity: "Nixelt"
        },
        {
          id: 41,
          value: 11,
          entity: "Yogasm"
        },
        {
          id: 42,
          value: 33,
          entity: "Acruex"
        },
        {
          id: 43,
          value: 28,
          entity: "Fitcore"
        },
        {
          id: 44,
          value: 11,
          entity: "Verton"
        },
        {
          id: 45,
          value: 50,
          entity: "Ontagene"
        },
        {
          id: 46,
          value: 24,
          entity: "Paragonia"
        },
        {
          id: 47,
          value: 80,
          entity: "Proxsoft"
        },
        {
          id: 48,
          value: 19,
          entity: "Applideck"
        },
        {
          id: 49,
          value: 15,
          entity: "Zaya"
        },
        {
          id: 50,
          value: 11,
          entity: "Halap"
        },
        {
          id: 51,
          value: 62,
          entity: "Ezent"
        },
        {
          id: 52,
          value: 25,
          entity: "Oronoko"
        },
        {
          id: 53,
          value: 87,
          entity: "Enormo"
        },
        {
          id: 54,
          value: 17,
          entity: "Keeg"
        },
        {
          id: 55,
          value: 65,
          entity: "Renovize"
        },
        {
          id: 56,
          value: 65,
          entity: "Trollery"
        },
        {
          id: 57,
          value: 93,
          entity: "Glasstep"
        },
        {
          id: 58,
          value: 76,
          entity: "Comcur"
        },
        {
          id: 59,
          value: 26,
          entity: "Peticular"
        },
        {
          id: 60,
          value: 54,
          entity: "Inear"
        },
        {
          id: 61,
          value: 54,
          entity: "Combogen"
        },
        {
          id: 62,
          value: 87,
          entity: "Isosure"
        },
        {
          id: 63,
          value: 58,
          entity: "Eternis"
        },
        {
          id: 64,
          value: 29,
          entity: "Exoplode"
        },
        {
          id: 65,
          value: 21,
          entity: "Orboid"
        },
        {
          id: 66,
          value: 34,
          entity: "Zork"
        },
        {
          id: 67,
          value: 34,
          entity: "Webiotic"
        },
        {
          id: 68,
          value: 78,
          entity: "Gracker"
        },
        {
          id: 69,
          value: 40,
          entity: "Hatology"
        },
        {
          id: 70,
          value: 15,
          entity: "Eventix"
        },
        {
          id: 71,
          value: 58,
          entity: "Tropoli"
        },
        {
          id: 72,
          value: 89,
          entity: "Brainclip"
        },
        {
          id: 73,
          value: 68,
          entity: "Primordia"
        },
        {
          id: 74,
          value: 12,
          entity: "Jimbies"
        },
        {
          id: 75,
          value: 52,
          entity: "Zillan"
        },
        {
          id: 76,
          value: 16,
          entity: "Trasola"
        },
        {
          id: 77,
          value: 85,
          entity: "Kindaloo"
        },
        {
          id: 78,
          value: 27,
          entity: "Valpreal"
        },
        {
          id: 79,
          value: 27,
          entity: "Pholio"
        },
        {
          id: 80,
          value: 62,
          entity: "Cipromox"
        },
        {
          id: 81,
          value: 29,
          entity: "Incubus"
        },
        {
          id: 82,
          value: 79,
          entity: "Bovis"
        },
        {
          id: 83,
          value: 83,
          entity: "Uni"
        },
        {
          id: 84,
          value: 73,
          entity: "Optyk"
        },
        {
          id: 85,
          value: 10,
          entity: "Telequiet"
        },
        {
          id: 86,
          value: 94,
          entity: "Enervate"
        },
        {
          id: 87,
          value: 93,
          entity: "Caxt"
        },
        {
          id: 88,
          value: 90,
          entity: "Genekom"
        },
        {
          id: 89,
          value: 16,
          entity: "Coriander"
        },
        {
          id: 90,
          value: 41,
          entity: "Insuresys"
        },
        {
          id: 91,
          value: 24,
          entity: "Netbook"
        },
        {
          id: 92,
          value: 32,
          entity: "Oceanica"
        },
        {
          id: 93,
          value: 36,
          entity: "Fossiel"
        },
        {
          id: 94,
          value: 57,
          entity: "Intrawear"
        },
        {
          id: 95,
          value: 35,
          entity: "Geekus"
        },
        {
          id: 96,
          value: 78,
          entity: "Exovent"
        },
        {
          id: 97,
          value: 94,
          entity: "Fortean"
        },
        {
          id: 98,
          value: 48,
          entity: "Recritube"
        },
        {
          id: 99,
          value: 12,
          entity: "Comdom"
        },
        {
          id: 100,
          value: 20,
          entity: "Izzby"
        },
        {
          id: 101,
          value: 68,
          entity: "Kog"
        },
        {
          id: 102,
          value: 76,
          entity: "Combot"
        },
        {
          id: 103,
          value: 86,
          entity: "Irack"
        },
        {
          id: 104,
          value: 25,
          entity: "Earthmark"
        },
        {
          id: 105,
          value: 79,
          entity: "Golistic"
        },
        {
          id: 106,
          value: 87,
          entity: "Terragen"
        },
        {
          id: 107,
          value: 84,
          entity: "Tetak"
        },
        {
          id: 108,
          value: 75,
          entity: "Lunchpad"
        },
        {
          id: 109,
          value: 52,
          entity: "Zilla"
        },
        {
          id: 110,
          value: 22,
          entity: "Momentia"
        },
        {
          id: 111,
          value: 41,
          entity: "Cinesanct"
        },
        {
          id: 112,
          value: 27,
          entity: "Insectus"
        },
        {
          id: 113,
          value: 71,
          entity: "Geeky"
        },
        {
          id: 114,
          value: 32,
          entity: "Otherside"
        },
        {
          id: 115,
          value: 71,
          entity: "Quinex"
        },
        {
          id: 116,
          value: 17,
          entity: "Bluplanet"
        },
        {
          id: 117,
          value: 40,
          entity: "Comtrail"
        },
        {
          id: 118,
          value: 86,
          entity: "Opticom"
        },
        {
          id: 119,
          value: 33,
          entity: "Farmex"
        },
        {
          id: 120,
          value: 16,
          entity: "Norsul"
        },
        {
          id: 121,
          value: 72,
          entity: "Voratak"
        },
        {
          id: 122,
          value: 15,
          entity: "Spacewax"
        },
        {
          id: 123,
          value: 38,
          entity: "Zboo"
        },
        {
          id: 124,
          value: 16,
          entity: "Emtrac"
        },
        {
          id: 125,
          value: 41,
          entity: "Rooforia"
        },
        {
          id: 126,
          value: 54,
          entity: "Urbanshee"
        },
        {
          id: 127,
          value: 10,
          entity: "Ramjob"
        },
        {
          id: 128,
          value: 40,
          entity: "Moltonic"
        },
        {
          id: 129,
          value: 69,
          entity: "Nurplex"
        },
        {
          id: 130,
          value: 25,
          entity: "Gluid"
        },
        {
          id: 131,
          value: 34,
          entity: "Neptide"
        },
        {
          id: 132,
          value: 68,
          entity: "Slofast"
        },
        {
          id: 133,
          value: 79,
          entity: "Norali"
        },
        {
          id: 134,
          value: 21,
          entity: "Comtour"
        },
        {
          id: 135,
          value: 60,
          entity: "Deviltoe"
        },
        {
          id: 136,
          value: 72,
          entity: "Bolax"
        },
        {
          id: 137,
          value: 15,
          entity: "Mantrix"
        },
        {
          id: 138,
          value: 14,
          entity: "Isoternia"
        },
        {
          id: 139,
          value: 81,
          entity: "Bulljuice"
        },
        {
          id: 140,
          value: 65,
          entity: "Enaut"
        },
        {
          id: 141,
          value: 77,
          entity: "Myopium"
        },
        {
          id: 142,
          value: 73,
          entity: "Zanymax"
        },
        {
          id: 143,
          value: 47,
          entity: "Corporana"
        },
        {
          id: 144,
          value: 84,
          entity: "Eargo"
        },
        {
          id: 145,
          value: 66,
          entity: "Geekola"
        },
        {
          id: 146,
          value: 72,
          entity: "Turnabout"
        },
        {
          id: 147,
          value: 89,
          entity: "Portaline"
        },
        {
          id: 148,
          value: 81,
          entity: "Daisu"
        },
        {
          id: 149,
          value: 64,
          entity: "Eplode"
        },
        {
          id: 150,
          value: 84,
          entity: "Joviold"
        },
        {
          id: 151,
          value: 39,
          entity: "Metroz"
        },
        {
          id: 152,
          value: 35,
          entity: "Accidency"
        },
        {
          id: 153,
          value: 49,
          entity: "Assurity"
        },
        {
          id: 154,
          value: 32,
          entity: "Hopeli"
        },
        {
          id: 155,
          value: 16,
          entity: "Uplinx"
        },
        {
          id: 156,
          value: 53,
          entity: "Locazone"
        },
        {
          id: 157,
          value: 88,
          entity: "Portico"
        },
        {
          id: 158,
          value: 62,
          entity: "Tasmania"
        },
        {
          id: 159,
          value: 68,
          entity: "Vetron"
        },
        {
          id: 160,
          value: 66,
          entity: "Netropic"
        },
        {
          id: 161,
          value: 91,
          entity: "Kegular"
        },
        {
          id: 162,
          value: 67,
          entity: "Velos"
        },
        {
          id: 163,
          value: 23,
          entity: "Ginkle"
        },
        {
          id: 164,
          value: 46,
          entity: "Strozen"
        },
        {
          id: 165,
          value: 55,
          entity: "Zillacon"
        },
        {
          id: 166,
          value: 78,
          entity: "Sulfax"
        },
        {
          id: 167,
          value: 64,
          entity: "Daido"
        },
        {
          id: 168,
          value: 32,
          entity: "Megall"
        },
        {
          id: 169,
          value: 80,
          entity: "Stelaecor"
        },
        {
          id: 170,
          value: 27,
          entity: "Furnitech"
        },
        {
          id: 171,
          value: 62,
          entity: "Grainspot"
        },
        {
          id: 172,
          value: 52,
          entity: "Rodeocean"
        },
        {
          id: 173,
          value: 86,
          entity: "Qualitex"
        },
        {
          id: 174,
          value: 34,
          entity: "Opportech"
        },
        {
          id: 175,
          value: 88,
          entity: "Enjola"
        },
        {
          id: 176,
          value: 55,
          entity: "Avenetro"
        },
        {
          id: 177,
          value: 13,
          entity: "Tourmania"
        },
        {
          id: 178,
          value: 20,
          entity: "Hyplex"
        },
        {
          id: 179,
          value: 47,
          entity: "Kyaguru"
        },
        {
          id: 180,
          value: 50,
          entity: "Parleynet"
        },
        {
          id: 181,
          value: 67,
          entity: "Hawkster"
        },
        {
          id: 182,
          value: 93,
          entity: "Zialactic"
        },
        {
          id: 183,
          value: 76,
          entity: "Vicon"
        },
        {
          id: 184,
          value: 26,
          entity: "Dognosis"
        },
        {
          id: 185,
          value: 71,
          entity: "Snips"
        },
        {
          id: 186,
          value: 67,
          entity: "Eplosion"
        },
        {
          id: 187,
          value: 62,
          entity: "Comstar"
        },
        {
          id: 188,
          value: 72,
          entity: "Olympix"
        },
        {
          id: 189,
          value: 54,
          entity: "Boilcat"
        },
        {
          id: 190,
          value: 16,
          entity: "Farmage"
        },
        {
          id: 191,
          value: 37,
          entity: "Temorak"
        }
      ]
    };
  }

  componentDidMount() {
    this.drawGraph();
  }

  componentDidUpdate(prevProps) {
    if (this.props.theme !== prevProps.theme) {
      this.drawGraph();
    }
  }

  drawGraph = () => {
    let isSecondary = !!this.props.secondary;
    let { data } = this.state;
    let { onServiceFilter } = this.props;

    var container = d3.select(this.graph);

    let containerWidth = container.node().getBoundingClientRect().width,
      containerHeight = container.node().getBoundingClientRect().height;

    var marginSets = {
      desktop: { top: 10, right: 55, bottom: 10, left: 55 },
      mobile: { top: 10, right: 25, bottom: 10, left: 25 }
    };

    var margin =
        window.innerWidth < 575 ? marginSets.mobile : marginSets.desktop,
      tickSizeTop = 20,
      width = containerWidth - margin.left - margin.right,
      height = containerHeight - margin.top - margin.bottom,
      circleMargin = 8,
      circleRadius = 5;

    // For Screenwidth > 1800px
    if (window.innerWidth > 1800) {
      circleMargin = 11;
      circleRadius = 7;
    } else if (window.innerWidth < 575) {
      circleRadius = 3.53;
      circleMargin = 5;
    }

    //Remove Previous
    container.select("svg").remove();

    var svg = container
      .append("svg")
      .attr("width", width + margin.right + margin.left)
      .attr("height", height + margin.top + margin.bottom);

    var formatValue = d3.format(",d");

    var x = d3.scaleLinear().rangeRound([0, width]);

    var g = svg
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    //Find count in each bracket
    var countData = [0, 0, 0, 0, 0];

    data.map(item => {
      if (item.value <= 20) {
        countData[0] += 1;
      } else if (item.value > 20 && item.value <= 40) {
        countData[1] += 1;
      } else if (item.value > 40 && item.value <= 60) {
        countData[2] += 1;
      } else if (item.value > 60 && item.value <= 80) {
        countData[3] += 1;
      } else if (item.value > 80 && item.value <= 100) {
        countData[4] += 1;
      }
    });

    x.domain([0, 100]);

    var simulation = d3
      .forceSimulation(data)
      .force(
        "x",
        d3
          .forceX(function(d) {
            return x(d.value);
          })
          .strength(1)
      )
      .force("y", d3.forceY(height / 2 + tickSizeTop))
      .force("collide", d3.forceCollide(circleMargin))
      .stop();

    for (var i = 0; i < 120; ++i) simulation.tick();

    g.append("g")
      .attr("class", "bubble-axis axis--x")
      .attr("transform", "translate(0,0)")
      .call(
        d3
          .axisBottom(x)
          .ticks(5)
          .tickSize(tickSizeTop)
      );

    g.append("g")
      .attr("class", "bubble-central-axis")
      .attr("transform", "translate(0," + (height / 2 + tickSizeTop) + ")")
      .call(
        d3
          .axisTop(x)
          .ticks(1)
          .tickSize(15)
      );

    g.append("g")
      .attr("class", "bubble-central-axis")
      .attr("transform", "translate(0," + (height / 2 + tickSizeTop) + ")")
      .call(
        d3
          .axisBottom(x)
          .ticks(1)
          .tickSize(15)
      );

    //Percentage Labels
    var zeroPerText = g
      .append("text")
      .attr("class", "bubble-percentageValue")
      .attr("text-anchor", "end")
      .attr("dominant-baseline", "central")
      .text("0%")
      .attr("x", -10)
      .attr("y", height / 2 + tickSizeTop);

    var hundredPerText = g
      .append("text")
      .attr("class", "bubble-percentageValue")
      .attr("text-anchor", "start")
      .attr("dominant-baseline", "central")
      .text("100%")
      .attr("x", width + 10)
      .attr("y", height / 2 + tickSizeTop);

    if (getDevice() === devices.mobile) {
      zeroPerText
        .attr("text-anchor", "middle")
        .attr("transform", "rotate(90,-10," + (height / 2 + tickSizeTop) + ")");

      hundredPerText
        .attr("text-anchor", "middle")
        .attr(
          "transform",
          "rotate(90," + (width + 10) + "," + +(height / 2 + tickSizeTop) + ")"
        );
    }

    //Counts in each bracket
    var countTexts = g
      .append("g")
      .attr("class", "bubble-counts")
      .selectAll("g")
      .data(countData);

    const stepWidth = width / 5;

    countTexts
      .enter()
      .append("text")
      .attr("text-anchor", "middle")
      .attr("dominant-baseline", "central")
      .attr("x", function(d, i) {
        return stepWidth / 2 + i * stepWidth;
      })
      .attr("y", 15)
      .text(function(d) {
        return d;
      });

    countTexts
      .enter()
      .append("text")
      .attr("text-anchor", "middle")
      .attr("dominant-baseline", "central")
      .attr("class", "small")
      .attr("x", function(d, i) {
        return stepWidth / 2 + i * stepWidth;
      })
      .attr("y", 30)
      .text("خــدمــة");

    // Plotting the circles in graph
    var cell = g
      .append("g")
      .attr("class", !!isSecondary ? "bubble-cells-secondary" : "bubble-cells")
      .selectAll("g")
      .data(
        d3
          .voronoi()
          .extent([
            [-margin.left, -margin.top],
            [width + margin.right, height + margin.top]
          ])
          .x(function(d) {
            return d.x;
          })
          .y(function(d) {
            return d.y;
          })
          .polygons(data)
      )
      .enter()
      .append("g");

    cell
      .append("circle")
      .attr("r", circleRadius)
      .attr("cx", function(d) {
        return d.data.x;
      })
      .attr("cy", function(d) {
        return d.data.y;
      });

    cell
      .append("path")
      .attr("d", function(d) {
        return "M" + d.join("L") + "Z";
      })
      .on("click", function() {
        onServiceFilter();
      });

    cell.append("title").text(function(d) {
      return d.data.entity + "\n" + formatValue(d.data.value);
    });
  };

  render() {
    return <GraphContainer ref={el => (this.graph = el)} className="graph" />;
  }
}
const mapStateToProps = state => ({
  theme: state.themes.theme
});

export default connect(
  mapStateToProps,
  null
)(ServicesBubbleGraph);
